export const CUSTOM_TAB_VIEW_PREFIX = 'tab:'

export const customTabView = (tabId: string): string =>
  `${CUSTOM_TAB_VIEW_PREFIX}${tabId}`

export const customTabIdFromView = (view: unknown): string | null =>
  typeof view === 'string' && view.startsWith(CUSTOM_TAB_VIEW_PREFIX)
    ? view.slice(CUSTOM_TAB_VIEW_PREFIX.length) || null
    : null

/** Hidden ExportButton id — must be unique per tab because every custom tab stays mounted. */
export const customTabExportButtonId = (tabId: string): string =>
  `dashboard-custom-tab-${tabId}-export-button`

/** null means the URL names a custom tab and must not update Redux viewIndex. */
export const builtInViewIndexFromUrl = (
  view: unknown,
  viewList: string[],
): number | null => {
  if (customTabIdFromView(view)) return null
  if (typeof view !== 'string') return 0
  const index = viewList.indexOf(view)
  return index >= 0 ? index : 0
}

export const safeBuiltInView = (viewList: string[], viewIndex: number): string =>
  viewList[viewIndex >= 0 && viewIndex < viewList.length ? viewIndex : 0] || 'overview'

